var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseButton',{staticClass:"flex-auto",attrs:{"success":"","outline":"","small":""},on:{"click":_vm.onManageReviews}},[_vm._v(" Manage reviews ")])
}
var staticRenderFns = []

export { render, staticRenderFns }